export function setAccountNameIntoLocalStorage(name:string) {
    localStorage.setItem("accountName", name);
  }
export function getAccountNameFromLocalStorage() {
    return localStorage.getItem("accountName");
  }

export function clearBrowserStorage() {
    localStorage.clear();
    sessionStorage.clear();
  }